module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-w flex stretch calendar-appointments-wrapper"
  }, [_c('div', {
    ref: "timeframes",
    staticClass: "timebar-container flex-column"
  }, _vm._l((_vm.timeframes), function(t) {
    return _c('div', {
      staticClass: "timebar-content flex-column end"
    }, [_c('span', {
      staticClass: "timebar-content--time"
    }, [_vm._v(_vm._s(t))]), _vm._v(" "), _c('span', {
      staticClass: "timebar-content--half"
    }, [_vm._v("30")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "full-w flex",
    staticStyle: {
      "height": "100%"
    }
  }, _vm._l((_vm.daysArray()), function(d) {
    return _c('v-calendar-day', {
      attrs: {
        "day": _vm.changeDay(_vm.day, 'add', d),
        "list": _vm.appointments,
        "create": _vm.create,
        "edit": _vm.onEdit
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edc3ea6a","hasScoped":false}!./src/app/components/calendar/calendar.html
// module id = 3133
// module chunks = 1